import axios from "axios";

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  let browserType = "Unknown";
  let browserVersion = "Unknown";

  if (
    userAgent.includes("Chrome") &&
    !userAgent.includes("Edg") &&
    !userAgent.includes("OPR")
  ) {
    browserType = "Chrome";
    browserVersion = userAgent.match(/Chrome\/(\d+\.\d+)/)?.[1] || "Unknown";
  } else if (userAgent.includes("Firefox")) {
    browserType = "Firefox";
    browserVersion = userAgent.match(/Firefox\/(\d+\.\d+)/)?.[1] || "Unknown";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    browserType = "Safari";
    browserVersion = userAgent.match(/Version\/(\d+\.\d+)/)?.[1] || "Unknown";
  } else if (userAgent.includes("Edg")) {
    browserType = "Edge";
    browserVersion = userAgent.match(/Edg\/(\d+\.\d+)/)?.[1] || "Unknown";
  } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
    browserType = "Opera";
    browserVersion = userAgent.match(/OPR\/(\d+\.\d+)/)?.[1] || "Unknown";
  } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
    browserType = "Internet Explorer";
    browserVersion = userAgent.match(/(MSIE |rv:)(\d+\.\d+)/)?.[2] || "Unknown";
  }

  return { browserType, browserVersion };
};

export const getOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const platform = navigator.platform;

  if (/Windows NT 10.0/.test(userAgent)) return "Windows 10";
  if (/Windows NT 6.2/.test(userAgent)) return "Windows 8";
  if (/Windows NT 6.1/.test(userAgent)) return "Windows 7";
  if (/Windows NT 6.0/.test(userAgent)) return "Windows Vista";
  if (/Windows NT 5.1/.test(userAgent) || /Windows XP/.test(userAgent))
    return "Windows XP";
  if (/Mac/.test(platform)) return "macOS";
  if (/iPhone|iPad|iPod/.test(userAgent)) return "iOS";
  if (/Android/.test(userAgent)) return "Android";
  if (/Linux/.test(platform)) return "Linux";

  return "Unknown";
};

export const getDeviceType = () => {
  const userAgent = navigator.userAgent;

  if (/Mobi|Android/i.test(userAgent)) {
    return "Smartphone";
  } else if (/Tablet|iPad/i.test(userAgent)) {
    return "Tablet";
  }
  return "Desktop";
};

export const getDeviceName = () => {
  const userAgent = navigator.userAgent;

  // Check for various devices
  if (/iPad/i.test(userAgent)) {
    return "iPad";
  } else if (/iPhone/i.test(userAgent)) {
    return "iPhone";
  } else if (/Android/i.test(userAgent)) {
    const deviceMatch = userAgent.match(/Android\s([0-9\.]+)/);
    return deviceMatch ? `Android Device ${deviceMatch[1]}` : "Android Device";
  } else if (/Windows NT/i.test(userAgent)) {
    return "Windows PC";
  } else if (/Macintosh/i.test(userAgent)) {
    return "Mac";
  } else if (/Linux/i.test(userAgent)) {
    return "Linux Device";
  } else {
    return "Unknown Device";
  }
};

export const getClientIp = async () => {
  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return "0.0.0.0";
  }
};

